import { render, staticRenderFns } from "./MessageAllDriversDialog.vue?vue&type=template&id=5fe7afdc&scoped=true&"
import script from "./MessageAllDriversDialog.vue?vue&type=script&lang=js&"
export * from "./MessageAllDriversDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe7afdc",
  null
  
)

export default component.exports